import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "safedate" })
export class SafeDatePipe implements PipeTransform {
  transform(value: any, format: string): string {
    if (!value) return "-";

    var str = (value + "").trim();
    var date: Date;

    // "YYYY-MM-DD"
    var ymdDash = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (ymdDash) {
      date = new Date(ymdDash[1] + "-" + ymdDash[2] + "-" + ymdDash[3]);
    }

    // "MM-DD-YYYY" e.g. "07-25-2019"
    else {
      var mdyDash = str.match(/^(\d{2})-(\d{2})-(\d{4})$/);
      if (mdyDash) {
        date = new Date(mdyDash[3] + "-" + mdyDash[1] + "-" + mdyDash[2]);
      }
    }

    // "MM/DD/YYYY"
    if (!date) {
      var mdySlash = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (mdySlash) {
        date = new Date(mdySlash[3] + "-" + mdySlash[1] + "-" + mdySlash[2]);
      }
    }

    // "YYYY/MM/DD"
    if (!date) {
      var ymdSlash = str.match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
      if (ymdSlash) {
        date = new Date(ymdSlash[1] + "-" + ymdSlash[2] + "-" + ymdSlash[3]);
      }
    }

    // "Jan 2020"
    if (!date) {
      var monthNameYear = str.match(/^([A-Za-z]+)\s+(\d{4})$/);
      if (monthNameYear) {
        var months = {
          jan: "01", feb: "02", mar: "03", apr: "04",
          may: "05", jun: "06", jul: "07", aug: "08",
          sep: "09", oct: "10", nov: "11", dec: "12"
        };
        var m = months[monthNameYear[1].toLowerCase().slice(0, 3)];
        if (m) {
          date = new Date(monthNameYear[2] + "-" + m + "-01");
        }
      }
    }

    // "YYYY-MM-DD HH:mm:ss"
    if (!date) {
      var isoSpace = str.match(/^(\d{4}-\d{2}-\d{2})\s(\d{2}:\d{2}:\d{2})/);
      if (isoSpace) {
        date = new Date(isoSpace[1] + "T" + isoSpace[2]);
      }
    }

    // Fallback
    if (!date) {
      date = new Date(str);
    }

    // Final NaN guard
    if (!date || isNaN(date.getTime())) return value;

    // Format manually based on common format strings
    var dd   = ("0" + date.getDate()).slice(-2);
    var mm   = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    var mmm  = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][date.getMonth()];

    if (format === "dd MMM yyyy") return dd + " " + mmm + " " + yyyy;
    if (format === "MMM yyyy")    return mmm + " " + yyyy;
    if (format === "dd/MM/yyyy")  return dd + "/" + mm + "/" + yyyy;
    if (format === "MM/dd/yyyy")  return mm + "/" + dd + "/" + yyyy;
    if (format === "yyyy-MM-dd")  return yyyy + "-" + mm + "-" + dd;
    if (format === "dd-MM-yyyy")  return dd + "-" + mm + "-" + yyyy;
    if (format === "MM-dd-yyyy")  return mm + "-" + dd + "-" + yyyy;

    // Default fallback format
    return dd + " " + mmm + " " + yyyy;
  }
}